// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\routes\\\\events.bk.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\routes\\events.bk.tsx");
  import.meta.hot.lastModified = "1757171103360.6035";
}
// REMIX HMR END

export const meta = () => {
  return [{
    title: "Events | Nomadics"
  }, {
    name: "description",
    content: "Upcoming creative events and workshops"
  }];
};
export default function Events() {
  return <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-6">Events</h1>
      <p className="text-lg text-muted-foreground">
        Discover upcoming events, workshops, and gatherings.
      </p>
    </div>;
}
_c = Events;
var _c;
$RefreshReg$(_c, "Events");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;